interface DecodedIdTokenPayload {
  sub: string;
  tenantId: string;
  name: string;
  email: string;
  impersonatedBySub: string;
  nbf: number;
  exp: number;
  iat: number;
}

export function decodeIdToken(
  idToken: string | null
): DecodedIdTokenPayload | null {
  if (!idToken) {
    return null;
  }
  try {
    const payloadBase64 = idToken.split('.')[1];
    if (!payloadBase64) {
      console.error('Invalid ID token format: Missing payload part.');
      return null;
    }
    const decodedJson = atob(
      payloadBase64.replace(/-/g, '+').replace(/_/g, '/')
    );
    return JSON.parse(decodedJson);
  } catch (error) {
    console.error('Error decoding or parsing ID token:', error);
    return null;
  }
}
